<div id="svelte-theme-container">
  <slot />
</div>

<style>
  :global(#svelte-theme-container) {
    --neutral-900: #1d2835;
    --neutral-800: #2c3d50;
    --neutral-700: #5f7083;
    --neutral-600: #798a9d;
    --neutral-500: #92a3b6;
    --neutral-400: #b3bcc6;
    --neutral-300: #ced4d9;
    --neutral-200: #e6ebf0;
    --neutral-100: #f0f2f5;
    --neutral-050: #f6f7f9;

    --royalBlue-500: #371dd3;
    --royalBlue-400: #4a4cd7;
    --royalBlue-300: #7d7ed6;
    --royalBlue-200: #a6a6ed;

    --red-500: #e50000;
    --red-400: #fd4a44;
    --red-300: #ff8b87;
    --red-200: #ffcccb;

    --pink-500: #d3276a;
    --pink-400: #e75e8d;
    --pink-300: #fdb9d1;

    --violet--500: #6b419c;
    --violet--400: #8b6daf;
    --violet--300: #b8a5d0;

    --yellow-500: #fbcb64;
    --yellow-400: #fad991;
    --yellow-300: #ffedc7;

    --green-500: #0ed3a4;
    --green-400: #5de4c4;
    --green-300: #acf5db;

    --skyBlue-500: #3790eb;
    --skyBlue-400: #81b8f0;
    --skyBlue-300: #b6d7f8;

    --gradient-1: linear-gradient(
      45deg,
      var(--royalBlue-500),
      var(--skyBlue-500)
    );
    --gradient-2: linear-gradient(
      45deg,
      var(--royalBlue-500),
      var(--green-400)
    );
    --gradient-2: linear-gradient(45deg, var(--royalBlue-500), var(--red-400));
    --gradient-2: linear-gradient(
      45deg,
      var(--royalBlue-500),
      var(--yellow-400)
    );

    --colors-text: var(--neutral-800);
    --colors-text-light: var(--neutral-600);

    font-family: "Basiercircle webfont", sans-serif;
  }
</style>
